// extracted by mini-css-extract-plugin
export default {"container":"Ao-z","bubbleNav":"Bo-z","graphic":"Co-z","contact":"Do-z"};